import React, { Component } from 'react';
import SearchBar from '../SearchBar/SearchBar';

class MainContainer extends Component {
    render () {
        return (
            <div>
                <SearchBar />
            </div>
        )
    }
}

export default MainContainer;